// 考试类
export default {
  TEST_GET_PRACTICES: '/api/exam/getPractices',            // 练习列表获取

  TEST_GET_QUESTIONS: '/api/exam/practice/getQuestions',   // 练习试题列表获取

  TEST_SAVE_ANSWERS: '/api/exam/practice/saveAnswers',     // 练习提交答案

  TEST_AI_JUDGE_SUBMIT: '/api/exam/practice/submitAiJudge', // 练习提交AI批改

  TEST_ANALYZE: '/api/exam/practice/analyze',              // 练习成绩报告

  TEST_REPORT: '/api/exam/practice/report',                // 练习分析

  TEST_RESTART: '/api/exam/practice/restart',              // 练习再来一次

  TEST_PAPER_CONFIG: '/api/exam/paper/config',             // 考试配置获取

  TEST_PAPER_QUESTIONS: '/api/exam/paper/questions',       // 考试试题获取

  TEST_GET_FILE_STS: '/api/test/paper/getSts',              // 考试上传文件参数

  FILE_GETSTS: '/api/file/getSts',                               // 俱乐部报告上传

  TEST_VIDEO_CONFIG: '/api/test/paper/videoConfig',        // 获取视频配置信息

  TEST_PAPER_REMAIN_TIMES: '/api/exam/paper/remainTimes',  // 获取考试剩余时间

  TEST_PAPER_SAVE_ANSWER: '/api/exam/paper/saveAnswers',    // 考试试卷答案提交

  TEST_EXAM_PAPER_REPORT: '/api/exam/paper/report',         // 获取考试结果报告

  TEST_EXAM_PAPER_ANALYZE: '/api/exam/paper/analyze',       // 获取考试分析

  TEST_BASE_64: '/api/common/upBase64',                     // 上传Base64

  TEST_GET_ALL_QUESTIONS: '/api/exam/bank/getQuestions',    // 一次获取全部的题目

  TEST_API_EXAM_PAPER_AI: '/api/exam/paper/ai',    // 1. 学生端获取作业的ai值

  TEST_PAPER_GET_CONFIG: '/api/test/paper/getExamConfig',   // 新考试配置获取

  TEST_PAPER_GETUSERSTATUS: '/api/test/paper/getUserStatus',  // 是否进入过考试  1:未进入过，2:进入过

  TEST_PAPER_GET_TIME: '/api/test/paper/getRemainTime',     // 新获取考试剩余时间

  TEST_PAPER_GET_PARPER: '/api/test/paper/getPaper',        // 新获取考试试卷

  TEST_TEST_SAVE_ANSWER: '/api/test/paper/saveAnswer',      // 考试试卷答案提交

  TEST_GET_ANSWER: '/api/test/paper/getAnswerRecord',       // 答题记录的

  TEST_INV_EXAM_TRANSACTION: '/api/test/invigilate/saveExamTransaction',   // 切屏 提交考试操作记录

  TEST_GET_REPORT: '/api/test/paper/getExamReport',         // 获取成绩报告

  TEST_QUESTION_ANSWERS: '/api/exam/paper/questionAnswers', // 同步考试答案

  TEST_PAPER_ANALYZE: '/api/test/paper/analyze',            // 答题分析

  TEST_PAPER_READMSG: '/api/test/paper/readMsg',             // 阅读提醒

  // 监考系统
  TEST_INV_PAPER_UPLOADREVIEWINFO: '/api/test/invigilate/uploadReviewInfo',    // 审核信息上传

  TEST_GETREVIEWRESULT: '/api/test/invigilate/getReviewResult',     // 获取审核结果

  TEST_INV_GETUSERMONITORDATA: '/api/test/invigilate/getUserMonitorData',    // 获取用户监考数据

  TEST_INV_UPDATEVIDEOSTATUS: '/api/test/invigilate/updateVideoStatus',      // 推流状态修改

  TEST_CONFIGMSG: '/api/test/invigilate/confirmMsg',                          // IM消息确认补偿

  TEST_MONITORGETOSSINFO: '/api/test/invigilate/getOssInfo',                 // 获取阿里云配置

  TEST_INV_GETCHATINFO: '/api/test/invigilate/getChatInfo',                 // 获取私信详情

  TEST_INV_SAVECHATCONTENT: '/api/test/invigilate/saveChatContent',         // 保存私信聊天记录

  TEST_INV_READCHAT: '/api/test/invigilate/readChat',                       // 私信已读

  TEST_GETHELP: '/api/test/invigilate/getHelp',                      // 求助

  TEST_MONITOR_GETAUTOANSWER: '/api/test/invigilate/getAutoAnswer',               // 获取自动回复

  TEST_MONITOR_ADDAUTORECORD: '/api/test/invigilate/addAutoRecord',        // 自动回复记录

  BATTLE_HANDPAPER: '/api/test/battle/handPaper',                    // 用户交卷

  TEST_INV_GETTESTCONFIG: '/api/test/invigilate/getTestConfig',   // 获取设备调试详情

  NEW_EQUIPMENT_GETINFO: '/api/test/equipment/getInfo',    // 获取设备调试信息（学生端）

  NEW_EQUIPMENT_SUBMITRESULT: '/api/test/equipment/submitResult',     // 提交检查项结果（学生端）

  NEW_CONTENT_CHAT_GETDETAIL: '/api/test/invigilate/chat/getDetail',   // 获取用户私信详情

  NEW_CONTENT_CHAT_SENDMSG: '/api/test/invigilate/chat/sendMsg',    // 发送私信

  NEW_INVIGILATE_AI_CHECKPHONEPIC: '/api/test/invigilate/ai/checkPhonePic'    // 手机监考画面AI检测（新增）
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/test.js